import { TraitModel } from '@common/models/TraitModel';
import { defaultTo } from 'lodash';
import { IModelWithTrait, ModelWithTrait } from './ModelWithTrait';
import { SalesItemModel } from './SalesItemModel';

export interface ISalesItemTraitModel extends IModelWithTrait {
  salesItemTraitId: number;
  salesItemId: number;
  // salesItem: ISalesItemModel;
}

export class SalesItemTraitModel
  extends ModelWithTrait
  implements ISalesItemTraitModel
{
  salesItemTraitId: number;
  salesItemId: number;
  // salesItem: ISalesItemModel;

  constructor(params: Partial<ISalesItemTraitModel>) {
    super(params);
    this.salesItemTraitId = defaultTo(params.salesItemTraitId, 0);
    this.salesItemId = defaultTo(params.salesItemId, 0);
  }

  static GetSalesItemTraitModelFromTraitModel(
    trait: Partial<TraitModel>,
    salesItem: Partial<SalesItemModel>,
  ) {
    return new SalesItemTraitModel({
      salesItemTraitId: 0,
      salesItemId: salesItem.salesItemId,
      traitId: trait.traitId,
      trait: new TraitModel(trait),
    });
  }
}
